module.exports = __webpack_public_path__ + "img/Ingress.16430034.svg";